import { render, staticRenderFns } from "./ActivePools.vue?vue&type=template&id=9d7def80&"
import script from "./ActivePools.vue?vue&type=script&lang=js&"
export * from "./ActivePools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports